export type LearningRolesData = string[];

export interface LaunchUrlData {
    launchUrl: string;
}

export const enum MissionCenterPermitionRoles {
    Manager = 'Manager',
}
